module.exports = "pegasus/assets/blocks/column-8-theme3.png";